import { Col, Row } from "react-bootstrap";
import "./events.css";
import React, { useState } from "react";


const ReadMoreText = ({ text }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    // Split content into words
    const words = text.trim().split(/\s+/);
    const wordLimit = 17;

    // Check if content exceeds limit
    const isLong = words.length > wordLimit;

    // Get preview content
    const previewText = words.slice(0, wordLimit).join(" ");

    return (
        <div>
            <p>
                {isExpanded || !isLong
                    ? text
                    : previewText + "..."}
            </p>

            {isLong && (
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    style={{
                        background: "none",
                        border: "none",
                        color: "blue",
                        cursor: "pointer",
                        padding: 0
                    }}
                >
                    {isExpanded ? "Read less" : "Read more"}
                </button>
            )}
        </div>
    );
};

function Alumenai(props) {
    const { data } = props;

    return (
        <>

            <div className="container mt-5">

                <h2>Welcome Back! </h2>

                <p>In the vibrant and spirited land of Jammu, your school stood as a
                    beacon of hope, strength, and purpose. Here, you learned to lead
                    with conviction and live with compassion. The values you carry
                    today still echo through these walls, and your return reminds us of
                    the brilliance that blossomed here.</p>
                <p>We invite you to take a moment to reconnect with the place that
                    helped shape your early dreams. By registering as an alumnus, you
                    open the doors to new opportunities — to network, mentor, share,
                    and celebrate life's unfolding journey with the community that
                    once nurtured you.  </p>
                <p>Here, we celebrate you — your milestones, your aspirations, and
                    the chapters you continue to write.  </p>


                <h3>Your presence here matters.</h3>
                <p>Every detail you share brings us closer to building a vibrant,   supportive, and united alumni family — one that inspires current students and strengthens the roots of our institution.  </p>

                <a href="https://forms.gle/oJJaNHnGCWLMcJSn7" target="_blank" className="btn btn-primary text-white">Step Back Into the HGS Jammu Spirit</a>

                <div className="row mt-4">
                    {data.map((item, i) => {
                        return (
                            (i % 2 == 0) ? (
                                <div className="col-lg-6" >
                                    <div className="news-card">
                                        <div className="news-text">
                                            <div className="news-date">
                                                <span className="news-day"> {item.title}</span>
                                            </div>
                                            <p className="mb-1"><b>{item.occupation}</b></p>
                                            <ReadMoreText text={item.description} />
                                        </div>
                                        <div className="news-img">
                                            <img src={item.image} alt={item.title} />
                                        </div>
                                    </div>
                                </div>)
                                : (
                                    <div className="col-lg-6">
                                        <div className="news-card flex-row-reverse">
                                            <div className="news-text text-end">
                                                <div className="news-date">
                                                    <span className="news-day"> {item.title}</span>
                                                </div>
                                                <p className="mb-1"><b>{item.occupation}</b></p>
                                                <ReadMoreText text={item.description} />
                                            </div>
                                            <div className="news-img">
                                                <img src={item.image} alt={item.title} />
                                            </div>
                                        </div>
                                    </div>
                                )
                        )

                    })}
                </div>

            </div>

        </>
    );
}

export default Alumenai;
